/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicMonitorV2ProviderDto } from './PublicMonitorV2ProviderDto';

/**
 * User qualification of a datapoint
 */
export type PublicMonitorV2DatapointQualificationDto = {
    /**
     * Anomaly status given by the user
     */
    anomalyStatus: PublicMonitorV2DatapointQualificationDto.anomalyStatus;
    comment?: string;
    createdAt?: string;
    createdBy?: PublicMonitorV2ProviderDto;
    /**
     * Qualification ID
     */
    id: string;
    modifiedAt?: string;
    modifiedBy?: PublicMonitorV2ProviderDto;
    reviewStatus: PublicMonitorV2DatapointQualificationDto.reviewStatus;
};

export namespace PublicMonitorV2DatapointQualificationDto {

    /**
     * Anomaly status given by the user
     */
    export enum anomalyStatus {
        ANOMALY = 'ANOMALY',
        NOT_ANOMALY = 'NOT_ANOMALY',
    }

    export enum reviewStatus {
        PENDING = 'PENDING',
        REVIEWED = 'REVIEWED',
    }


}
